/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import Vue from 'vue';
import Vuex from 'vuex';
import { stores } from 'lion-vue';
import authentication from '@/Authentication/store';
import { actions, campaigns, publishedCampaigns, campaignContacts } from '@/Campaigns/store';

// Add your file import to Contacts/store/index.js
// before adding to this import list
import {
  contact,
  contactsSearch,
  contactRelationships,
  contactsTable,
  contactFilters,
  contactsStatus,
  contactsSearchCampaign,
  contactsExport,
  customAudiences,
  customFields,
  contactCampaignComms,
  scheduleds,
  facebookBusiness,
  importContacts,
  emailManagement,
  emailActivity,
  emailAccounts,
  emailDomainAuth,
  emailLimits,
  emailSender,
  dialer,
  zipformTransaction,
  cma,
  contactsMaintenance,
  transactionDesk,
  qualify,
  leadsplus,
  integrations,
  importFile,
  contactsImport,
  emailSuppressions,
  importContactsFieldsMaps,
  importContactsReport,
  smsConsent,
} from '@/Contacts/store';
import {
  preferences,
  subAccounts,
  teamMembers,
  dailyVitals,
  eventList,
  reportingQualify,
  dashboardContactFilters,
  userInformation,
  userPreferences,
  payment,
} from '@/Core/store';
import { persistPreferences } from '@/Core/plugins/persist-preferences';
import {
  templates,
  recipients,
  communicationsCustomFields,
  shortCodes,
  leadAssist,
  optInForm,
} from '@/Communications/store';
import tasks from '@/Tasks/store';
import { videos } from '@/Media/store';
import { conversations, userSmsErrorRates, optInFormBuilder } from '@/Text/store';
import { evocalize, officeLookup, boost } from '@/Marketing/store';
import { contactSync } from '@/Email-Integrations/store';
import sunsetAdmin from '@/SunsetAdmin/store';
import {
  files,
  exportedFiles,
} from '@/Documents/store';
import { reportingV2, reportingGraph, filterReport, bulkActionsReport } from '@/Reporting/store';
import { onboarding } from '@/Onboarding/store';
import { registerCustomerA2p, registerLiteCustomerA2p, registerSoleProprietorA2p } from '@/a2p/store';
import {
  subAccountPermissions,
  leadsSources,
  contactTags,
  contactTypes,
  contactsAccountManagement,
  customFieldsAccountManagement,
  hotness,
  taskCategories,
  leadRoutes,
  leadSourceProviders,
  leadDistributionRules,
  leadDistributionMethods,
} from '@/AccountManagement/store';
import { emailVerification } from '@/ResendVerificationEmail/store';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,

  modules: {
    ...stores,
    authentication,
    campaigns,
    getAction: actions.modules.getAction,
    campaignAction: actions.modules.campaignAction,
    campaignContacts,
    preferences,
    contact,
    contactsStatus,
    contactsTable,
    contactsSearch,
    contactRelationships,
    contactsSearchCampaign,
    contactsExport,
    customAudiences,
    customFields,
    contactFilters,
    dailyVitals,
    dialer,
    eventList,
    facebookBusiness,
    userInformation,
    dashboardContactFilters,
    userPreferences,
    tasks,
    videos,
    templates,
    teamMembers,
    subAccounts,
    recipients,
    communicationsCustomFields,
    conversations,
    userSmsErrorRates,
    contactCampaignComms,
    scheduleds,
    shortCodes,
    publishedCampaigns,
    leadAssist,
    importContacts,
    emailManagement,
    evocalize,
    officeLookup,
    emailActivity,
    emailAccounts,
    emailDomainAuth,
    emailLimits,
    emailSender,
    zipformTransaction,
    contactSync,
    payment,
    files,
    exportedFiles,
    reportingV2,
    reportingGraph,
    filterReport,
    onboarding,
    registerCustomerA2p,
    registerLiteCustomerA2p,
    boost,
    cma,
    contactsMaintenance,
    transactionDesk,
    qualify,
    leadsplus,
    reportingQualify,
    bulkActionsReport,
    subAccountPermissions,
    leadsSources,
    contactTags,
    contactTypes,
    contactsAccountManagement,
    customFieldsAccountManagement,
    hotness,
    taskCategories,
    leadSourceProviders,
    leadDistributionRules,
    leadDistributionMethods,
    emailVerification,
    leadRoutes,
    registerSoleProprietorA2p,
    integrations,
    importFile,
    contactsImport,
    emailSuppressions,
    importContactsFieldsMaps,
    importContactsReport,
    smsConsent,
    optInForm,
    optInFormBuilder,
    sunsetAdmin,
  },

  plugins: [persistPreferences],
});
